<script setup>
import AppLogo from '@/components/app/AppLogo.vue'
import ActionButton from '@/components/shared/buttons/ActionButton.vue'
import {useCurrentUser} from '@/composables/use-current-user.js'
import {useAuthentication} from '@/composables/use-authentication.js'
import {useNavigation} from '@/composables/use-navigation.js'

//Composables
const {goToHome} = useNavigation()
const {user} = useCurrentUser()
const {redirectToLogout} = useAuthentication()
</script>

<template>
  <div :class="$style.wrapper">
    <div :class="$style.inner">
      <div :class="$style.logoWrapper">
        <AppLogo
          is-clickable
          @click="goToHome()"
        />
      </div>
      <div
        v-if="user"
        :class="$style.userWrapper"
      >
        <span>Logged in as {{ user.displayName }}</span>
        <ActionButton
          type="secondary"
          label="Log out"
          is-compact
          is-slim
          @click="redirectToLogout()"
        />
      </div>
    </div>
  </div>
</template>

<style module lang="scss">
.wrapper {
  background: var(--bg-page-top-bar);
  border-bottom: 1px solid var(--color-borders);
  height: var(--topbar-height);
  flex: 0 0 var(--topbar-height);
}
.inner {
  height: 100%;
  max-width: 768px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 auto;
  padding: 0 1.5rem;
  @media (min-width: 768px) {
    padding: 0 2rem;
  }
}
.logoWrapper {
  flex: 1;
}
.userWrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
</style>
